import Service from "./apiService";

class PodcastsGroupsService extends Service {
  getData() {
    return super.ajax({
      baseUrl: this.BACKEND_URL,
      path: `podcasts_groups`,
      method: "GET",
    });
  }

  get(id) {
    return super.ajax({
      baseUrl: this.BACKEND_URL,
      path: `podcasts_groups/${id}`,
      method: "GET",
    });
  }  

  add(form) {
    return super.ajax({
      baseUrl: this.BACKEND_URL,
      path: `podcasts_groups`,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(form),
    });
  }

  update(id, form) {
    return super.ajax({
      baseUrl: this.BACKEND_URL,
      path: `podcasts_groups/${id}`,
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(form),
    });
  }

  delete(id) {
    return super.ajax({
      baseUrl: this.BACKEND_URL,
      path: `podcasts_groups/${id}`,
      method: "DELETE",
    });
  }

}

export var podcastsGroupsService = new PodcastsGroupsService();
